import { RouteRecordRaw } from 'vue-router'

const adminRoutes: RouteRecordRaw[] = [
	{
		path: 'userMgtList',
		name: 'AdminUserMgtList',
		meta: { title: '用户查询' },
		component: () => import('@/views/admin/Layout/userMgt/list.vue')
	},
	{
		path: 'roleMgt',
		name: 'AdminRoleMgt',
		meta: { title: '角色管理' },
		children: [
			{
				path: 'roleConfigList',
				name: 'AdminRoleConfigList',
				meta: { title: '角色配置' },
				component: () => import('@/views/admin/Layout/roleMgt/roleConfigList/list.vue')
			},
			{
				path: 'roleMemberList',
				name: 'AdminRoleMemberList',
				meta: { title: '角色成员' },
				component: () => import('@/views/admin/Layout/roleMgt/roleMember/list.vue')
			}
		]
	},
	{
		path: 'dictsMgt',
		name: 'AdminDictsMgt',
		meta: { title: '字典管理' },
		children: [
			{
				path: 'dictsTypeList',
				name: 'AdminDictsMgtList',
				meta: { title: '字典类型' },
				component: () => import('@/views/admin/Layout/dictsMgt/dictsType/list.vue')
			},
			{
				path: 'dictsDataList',
				name: 'AdminDictsDataList',
				meta: { title: '字典数据' },
				component: () => import('@/views/admin/Layout/dictsMgt/dictsData/list.vue')
			}
		]
	},
	{
		path: 'generalMgtList',
		name: 'AdminGeneralMgtList',
		meta: { title: '前台管理' },
		component: () => import('@/views/admin/Layout/generalMgt/list.vue')
	},
	{
		path: 'labelMgt',
		name: 'AdminLabelMgt',
		meta: { title: '标签管理' },
		children: [
			{
				path: 'labelTypeList',
				name: 'AdminLabelTypeList',
				meta: { title: '标签分类' },
				component: () => import('@/views/admin/Layout/labelMgt/labelType/list.vue')
			},
			{
				path: 'labelDataList',
				name: 'AdminLabelDataList',
				meta: { title: '标签数据' },
				component: () => import('@/views/admin/Layout/labelMgt/labelData/list.vue')
			}
		]
	},
	{
		path: 'logsMgt',
		name: 'AdminLogsMgt',
		meta: { title: '日志管理' },
		children: [
			{
				path: 'generalLogsList',
				name: 'AdminGeneralLogsList',
				meta: { title: '前台日志' },
				component: () => import('@/views/admin/Layout/logsMgt/generalLogs/list.vue')
			},
			{
				path: 'adminLogsList',
				name: 'AdminAdminLogsList',
				meta: { title: '后台日志' },
				component: () => import('@/views/admin/Layout/logsMgt/adminLogs/list.vue')
			},
			{
				path: 'loginLogsList',
				name: 'AdminLoginLogsList',
				meta: { title: '登录日志' },
				component: () => import('@/views/admin/Layout/logsMgt/loginLogs/list.vue')
			},
			{
				path: 'interfaceLogsList',
				name: 'AdminInterfaceLogsList',
				meta: { title: '接口日志' },
				component: () => import('@/views/admin/Layout/logsMgt/interfaceLogs/list.vue')
			}
		]
	},
	{
		path: '/userCenter',
		name: 'UserCenter',
		meta: { title: '个人中心' },
		component: () => import('@/views/user-center/index.vue')
	},
	{
		path: '/recycleBin',
		name: 'recycleBin',
		meta: { title: '回收站' },
		component: () => import('@/views/recycle-bin/index.vue')
	}
]

export default adminRoutes
